import React from 'react';
import { Carousel } from 'react-bootstrap';

const JinniRelocation = () => {
    return (
        <div className="roadRiderzProject">
        <h1 className="projects-Header">Jinni Relocation</h1>
        <div className="row site-details-rrz">
          <div className="col-md-6 p-3">
            <p>
              * Jinni Relocation is a relocation platform make relocation service more comfortable and easier .
            </p>
            <p>
              * Using technologies are ReactJS, NodeJS, ExpressJS, MongoDB,
              Firebase, Heroku.
            </p>
            <p>
              * A fully functional full-stack web app basses on MERN stack. It has
              admin panel.
            </p>
            <p>* This Site hase two role one is use role another is admin role</p>
            <p>
              * This Site has Authentication system like google signin, register
              for new user with firebase.
            </p>
            <p>* Using React-Router version 6 </p>
          </div>
          <div className="col-md-6 p-3">
            <Carousel fade>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://i.ibb.co/d4gYKvm/jinni-1.png"
                  alt="First slide"
                />
                <Carousel.Caption>
                  {/* <h3>First slide label</h3>
                  <p>
                    Nulla vitae elit libero, a pharetra augue mollis interdum.
                  </p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://i.ibb.co/ydqt8mf/Screenshot-82-1.png"
                  alt="Second slide"
                />
  
                <Carousel.Caption>
                  {/* <h3>Second slide label</h3>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://i.ibb.co/V9XpDSk/Screenshot-83-1.png"
                  alt="Third slide"
                />
  
                <Carousel.Caption>
                  {/* <h3>Third slide label</h3>
                  <p>
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur.
                  </p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://i.ibb.co/0t1FnVh/Screenshot-85-1.png"
                  alt="Third slide"
                />
  
                <Carousel.Caption>
                  {/* <h3>Fourth slide label</h3>
                  <p>
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur.
                  </p> */}
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </div>
        </div>
       <div className="siteInfo">
       <h3 className="seeLive">See Live: </h3>
        <span >
          {" "}
          <a className="liveSite" target="_blank" href="https://jinni-relocation.firebaseapp.com/"><b>LiveSite</b></a>
        </span>
        <span >
          <a className="clientSide" target="_blank" href="https://github.com/Iasir-Arafat-riaz/Jnni-Relocation-ClientSide"><b>ClientSideCode</b></a>
        </span>
        <span>
          <a className="serverSide" target="_blank" href="https://github.com/Iasir-Arafat-riaz/Jnni-Relocation-Server"><b>ServerSideCode</b></a>
        </span>
       </div>
      </div>
    );
};

export default JinniRelocation;